import { Action } from './action';
import { LocaleCode } from 'acscp/translations';

export class ChangeLocaleFromUserDetails extends Action {
    constructor(public locale: LocaleCode) {
        super();
    }
}

export class ChangeLocaleManually extends Action {
    constructor(public locale: LocaleCode) {
        super();
    }
}

export class ChangeLocaleAutomatically extends Action {
    constructor(public locale: LocaleCode) {
        super();
    }
}

export class ChangeLocaleFromSharingLink extends Action {
    constructor(public locale: LocaleCode) {
        super();
    }
}
